<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Segnalazioni</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="showFilter">
              <v-icon color="purple"> mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="dialog_option = true"
              small
              v-bind="attrs"
              v-on="on"
              class="mr-5 ml-5"
            >
              <v-icon color="primary">mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>Impostazioni</span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push('/home/production')"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-row class="mt-1" v-if="filterVisible">
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            :items="ordini"
            v-model="ordFilter"
            label="Documento"
            class="ma-1"
            @change="changeFilters"
            outlined
            dense
          >
            <template v-slot:append>
              <v-icon
                @click="
                  ordFilter = 'tutti';
                  changeFilters();
                "
                color="error"
                v-if="ordFilter != 'tutti'"
              >
                mdi-close
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            :items="articoli"
            v-model="artFilter"
            label="Articolo"
            class="ma-1"
            @change="changeFilters"
            outlined
            dense
          >
            <template v-slot:append>
              <v-icon
                @click="
                  artFilter = 'tutti';
                  changeFilters();
                "
                color="error"
                v-if="artFilter != 'tutti'"
              >
                mdi-close
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            :items="tipi_segnalazione"
            v-model="tipFilter"
            item-text="des"
            item-value="id_tabella"
            label="Tipo"
            class="ma-1"
            @change="changeFilters"
            outlined
            dense
          >
            <template v-slot:append>
              <v-icon
                @click="
                  tipFilter = -1;
                  changeFilters();
                "
                color="error"
                v-if="tipFilter != -1"
              >
                mdi-close
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-autocomplete
            :items="tipologia_stato"
            v-model="statoFilter"
            item-text="des"
            item-value="id_tabella"
            label="Stato"
            class="ma-1"
            @change="changeFilters"
            outlined
            dense
          >
            <template v-slot:append>
              <v-icon
                @click="
                  statoFilter = -1;
                  changeFilters();
                "
                color="error"
                v-if="statoFilter != -1"
              >
                mdi-close
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-card-text>
        <v-data-table
          :items="filterVisible ? filtered : segnalazioni"
          :headers="headers"
          :key="tableKey"
          item-key="id_segnalazione"
          :single-expand="true"
          :expanded.sync="segnalazioni.lista_note"
          show-expand
          sort-by="id_segnalazione"
          sort-desc
        >
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  elevation="1"
                  class="mr-3"
                  @click="showSegnalazione(item)"
                >
                  <v-icon color="#1a80b6"> mdi-eye </v-icon>
                </v-btn>
              </template>
              <span>Dettaglio Segnalazione</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.des_stato`]="{ item }">
            <v-icon
              :color="
                item.stato == id_stato_open
                  ? 'error'
                  : item.stato == id_stato_progress
                  ? 'orange'
                  : item.stato == id_stato_closed
                  ? 'success'
                  : ''
              "
            >
              {{
                item.stato == id_stato_open
                  ? "mdi-bell"
                  : item.stato == id_stato_progress
                  ? "mdi-progress-wrench"
                  : item.stato == id_stato_closed
                  ? "mdi-check"
                  : ""
              }}
            </v-icon>
          </template>
          <template v-slot:[`item.des_esito`]="{ item }">
            <v-icon
              :color="
                item.esito == id_esito_nok
                  ? 'error'
                  : item.esito == id_esito_ok
                  ? 'success'
                  : ''
              "
            >
              {{
                item.esito == id_esito_nok
                  ? "mdi-close"
                  : item.esito == id_esito_ok
                  ? "mdi-check"
                  : ""
              }}
            </v-icon>
          </template>
          <template v-slot:[`item.num_documento`]="{ item }">
            <!--
              {{
              item.riferimento == "documento"
                ? item.documento_num_documento
                : item.riferimento == "documento_dettaglio"
                ? item.documento_dettaglio_num_documento
                : item.num_documento != null && item.num_documento != ""
                ? item.num_documento
                : "N/D"
            }}
            -->
            {{
              item.num_documento != null && item.num_documento != ""
                ? item.num_documento
                : "N/D"
            }}
          </template>
          <template v-slot:[`item.cod_articolo`]="{ item }">
            {{
              item.riferimento == "documento_dettaglio"
                ? item.cod_articolo
                : item.riferimento == "documento"
                ? "Intero Ordine"
                : item.cod_articolo
            }}
          </template>
          <template v-slot:[`item.tipo_segnalazione`]="{ item }">
            {{ getTipo(item.tipo) }}
          </template>
          <template v-slot:[`item.data_documento`]="{ item }">
            {{ formatData(item.data_documento) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              class="pa-0"
              style="background-color: white"
              :colspan="headers.length"
            >
              <v-data-table
                class="elevation-3"
                :headers="headers_note"
                hide-default-footer
                :items="item.lista_note"
                sort-by="id_segnalazione_nota"
                sort-desc
              >
                <!-- Bottone di modifica della nota -->
                <!-- <template v-slot:[`item.modifica`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="
                          nota_selez = item;
                          dialog_modifica_nota = true;
                        "
                        small
                        v-bind="attrs"
                        v-on="on"
                        v-show="item.ultima == true"
                      >
                        <v-icon color="primary"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica nota</span>
                  </v-tooltip>
                </template> -->
                <!-- Colonna della data di inserimento -->
                <template v-slot:[`item.date_ins`]="{ item }">
                  {{ formatData(item.date_ins) }}
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="segnalazioneDettaglio" width="700">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Segnalazione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di gestione di stato ed esito -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="gestisciStatoEsito" small>
                <v-icon color="primary"> mdi-certificate </v-icon>
              </v-btn>
            </template>
            <span>Gestisci Stato/Esito</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                @click="
                  segnalazioneDettaglio = false;
                  nuova_nota.des_azione = '';
                  nuova_nota.id_stato = null;
                "
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-card-text class="pb-10">
          <v-row class="mt-2">
            <v-col cols="6" class="mt-2">
              <v-row align="center" justify="start">
                <h3 style="font-weight: normal">Tipo:</h3>
                <h3>{{ getTipo(tempSegnalazione.tipo) }}</h3>
              </v-row>
              <v-row align="center" justify="start">
                <h3 style="font-weight: normal">Quantità:</h3>
                <h3>
                  {{
                    tempSegnalazione.quantita === null ||
                    tempSegnalazione.quantita === ""
                      ? "N/D"
                      : tempSegnalazione.quantita
                  }}
                </h3>
              </v-row>
              <v-row align="center" justify="start">
                <h3 style="font-weight: normal">Segnalato da:</h3>
                <h3>{{ tempSegnalazione.nome_utente }}</h3>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-textarea
                label="Note"
                outlined
                readonly
                rows="3"
                style="border-radius: 0px"
                v-model="tempSegnalazione.note"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-toolbar class="indigo white--text" dense>
            <v-toolbar-title class="white--text"> Allegati </v-toolbar-title>
          </v-toolbar>
          <v-row class="mt-5">
            <v-col v-for="index in immagini.length + 1" :key="index" cols="3">
              <img
                :src="immagini[index - 1]?.immagine"
                width="100"
                @click="openImage(immagini[index - 1]?.immagine)"
              />
            </v-col>
          </v-row>
          <v-toolbar class="indigo white--text" dense>
            <v-toolbar-title class="white--text">
              Aggiungi Note
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on" light @click="setNota(nuova_nota)">
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva nota</span>
            </v-tooltip>
          </v-toolbar>
          <v-row class="ml-5 mr-5" justify="end">
            <v-col cols="2"> </v-col>
          </v-row>
          <v-row class="ml-5 mr-5">
            <v-col cols="3">
              <v-autocomplete
                dense
                hide-details
                :items="tipi_segnalazione"
                outlined
                style="border-radius: 0px"
                v-model="nuova_nota.id_stato"
                item-text="des"
                item-value="id_tabella"
                label="Tipo"
              >
                <template #label>
                  <span class="">Tipo</span>
                  <span style="min-width: 500px; pointer-events: all">
                    <Modules
                      tipo="TIPOLOGIA_SEGNALAZIONE"
                      nome="Tipo nota"
                      setaction="settabella"
                      getaction="gettabella"
                      controller="Global"
                      :filter="'validita = 1'"
                      :dati="[{ des: '' }]"
                    />
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="9">
              <v-textarea
                dense
                hide-details
                outlined
                style="border-radius: 0px"
                rows="3"
                label="Testo"
                v-model="nuova_nota.des_azione"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showImage">
      <v-toolbar class="indigo white--text" dense>
        <v-toolbar-title class="white--text">
          Dettaglio Immagine
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- Bottone di download dell'immagine -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="saveImageAsFile(image_data)" small>
              <v-icon color="primary"> mdi-download </v-icon>
            </v-btn>
          </template>
          <span>Download</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <!-- Bottone di chiusura -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="showImage = false" small>
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card max-height="80vh" class="overflow-y-auto">
        <v-row align="center" justify="center">
          <div v-viewer class="images clearfix d-flex align-items-center">
            <img
              id="image_prev"
              :src="image_data"
              :lazy-src="image_data"
              aspect-ratio="1"
              class="grey lighten-2"
            />
          </div>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Modifica nota -->
    <v-dialog v-model="dialog_modifica_nota" max-width="600px">
      <v-toolbar class="indigo white--text" dense>
        <v-toolbar-title class="white--text"> Modifica nota </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="setNota(nota_selez)" small>
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="dialog_modifica_nota = false" small>
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card max-height="80vh" class="overflow-y-auto">
        <v-row align="center" justify="center" class="ml-5 mr-5">
          <v-col cols="9">
            <v-textarea
              rows="3"
              label="Testo"
              v-model="nota_selez.des_azione"
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              dense
              hide-details
              label="Stato"
              :items="tipologia_stato"
              item-text="des"
              item-value="id_tabella"
              placeholder="Seleziona"
              required
              v-model="nota_selez.id_stato"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Dialog impostazioni-->
    <v-dialog v-model="dialog_option" max-width="600px">
      <v-toolbar class="indigo white--text" dense>
        <v-toolbar-title class="white--text"> Impostazioni </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="
                setOpzioni();
                dialog_option = false;
              "
              small
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="dialog_option = false" small>
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card max-height="80vh" class="overflow-y-auto">
        <v-data-table
          :items="lista_profili_auto"
          :headers="headers_autorizzazioni"
          :key="key_tabella"
        >
          <!-- Slot che descrive la riga -->
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.des_profilo_utente }}</td>
              <!-- Sequenza di colonne descritte dagli header -->
              <td
                style="text-align: left"
                v-for="(it, idx) in headers_autorizzazioni.filter(
                  (h) => h.value != 'des_profilo_utente'
                )"
                :key="idx"
              >
                <v-icon
                  @click="switchAutorizzazione(item, it.value)"
                  :color="item[it.value].value === 1 ? 'success' : 'error'"
                >
                  {{ item[it.value].value === 1 ? "mdi-check" : "mdi-close" }}
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Dialog di gestione stato ed esito -->
    <v-dialog v-model="gestisci_stato_esito" width="unset">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">
            Gestione Stato ed Esito
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="saveGestisciStatoEsito()" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="gestisci_stato_esito = false" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-autocomplete
                  dense
                  hide-details
                  :items="tipologia_stato"
                  item-text="des"
                  item-value="id_tabella"
                  label="Stato"
                  outlined
                  style="border-radius: 0px"
                  v-model="id_stato_tmp"
                >
                  <template v-slot:item="{ item }">
                    <v-icon
                      class="mr-5"
                      :color="
                        item.id_tabella == id_stato_open
                          ? 'error'
                          : item.id_tabella == id_stato_progress
                          ? 'orange'
                          : item.id_tabella == id_stato_closed
                          ? 'success'
                          : ''
                      "
                    >
                      {{
                        item.id_tabella == id_stato_open
                          ? "mdi-bell"
                          : item.id_tabella == id_stato_progress
                          ? "mdi-progress-wrench"
                          : item.id_tabella == id_stato_closed
                          ? "mdi-check"
                          : ""
                      }}
                    </v-icon>
                    {{ item.des }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  dense
                  hide-details
                  :items="tipologia_esito"
                  item-text="des"
                  item-value="id_tabella"
                  label="Esito"
                  outlined
                  style="border-radius: 0px"
                  v-model="id_esito_tmp"
                >
                  <template v-slot:item="{ item }">
                    <v-icon
                      class="mr-5"
                      :color="
                        item.id_tabella == id_esito_nok
                          ? 'error'
                          : item.id_tabella == id_esito_ok
                          ? 'success'
                          : ''
                      "
                    >
                      {{
                        item.id_tabella == id_esito_nok
                          ? "mdi-close"
                          : item.id_tabella == id_esito_ok
                          ? "mdi-check"
                          : ""
                      }}
                    </v-icon>
                    {{ item.des }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment/moment";
/* import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  // HorizontalRule,
  History,
} from "tiptap-vuetify"; */

export default {
  name: "Segnalazioni",
  components: {
    SnackbarQV,
    Modules: () => import("@/components/TOOLS/Modules"),
    // TiptapVuetify,
  },
  data() {
    return {
      // Variabili di supporto
      allegatiTab: "",
      artFilter: "tutti",
      id_esito_nok: -1,
      id_esito_ok: -1,
      id_esito_tmp: null,
      id_stato_closed: -1,
      id_stato_open: -1,
      id_stato_progress: -1,
      id_stato_tmp: null,
      image_data: "",
      key_tabella: 0,
      nota_selez: {},
      nuova_nota: { des_azione: "", id_stato: null },
      ordFilter: "tutti",
      statoFilter: -1,
      tableKey: true,
      tempSegnalazione: {
        id_documento: this.id_documento,
        id_documento_dettaglio: null,
        tipo: 0,
        quantita: 0,
        note: "",
      },
      tipFilter: -1,

      // Modal
      dialog_modifica_nota: false,
      dialog_option: false,
      filterVisible: false,
      gestisci_stato_esito: false,
      loading: false,
      segnalazioneDettaglio: false,
      showImage: false,

      // Array
      articoli: ["tutti"],
      expanded: [],
      filtered: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "Dettaglio",
          value: "dettaglio",
        },
        {
          text: "Tipo",
          value: "tipo_segnalazione",
        },
        {
          text: "Documento",
          value: "cod_documento",
        },
        {
          text: "Numero",
          value: "num_documento",
        },
        {
          text: "Articolo",
          value: "cod_articolo",
        },
        {
          text: "Quantita",
          value: "quantita",
        },
        {
          text: "Data",
          value: "data_documento",
        },
        {
          text: "Segnalato da",
          value: "nome_utente",
        },
        /*         {
          text: "Quantita",
          value: "quantita",
        }, */
        /*         {
          text: "Note",
          value: "note",
        }, */
        // Processata/da processare con icona
        {
          text: "Stato",
          value: "des_stato",
        },
        // Da modules
        {
          text: "Esito",
          value: "des_esito",
        },
      ],
      headers_autorizzazioni: [],
      headers_note: [
        /* {
          text: "Modifica",
          value: "modifica",
        }, */
        {
          text: "Codice",
          value: "id_segnalazione_nota",
        },
        {
          text: "Nota di",
          value: "cognome",
        },
        {
          text: "Data",
          value: "date_ins",
        },
        {
          text: "Tipo",
          value: "des_stato",
        },
        {
          text: "Nota",
          value: "des_azione",
        },
      ],
      immagini: [],
      lista_profili: [],
      lista_profili_auto: [],
      note: [],
      ordini: ["tutti"],
      segnalazioni: [],
      tipi_segnalazione: [],
      tipologia_esito: [],
      tipologia_stato: [],
      /*  extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        // HorizontalRule,
        Paragraph,
        HardBreak,
      ], */
    };
  },
  async mounted() {
    this.gettabelle();
    await this.getProfili();
    this.getTabella();
    //this.getStati();
    await this.inizializza();
  },
  methods: {
    gestisciStatoEsito() {
      this.id_stato_tmp = this.tempSegnalazione.stato;
      this.id_esito_tmp = this.tempSegnalazione.esito;
      this.gestisci_stato_esito = true;
    },
    saveGestisciStatoEsito() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setstatoesitosegnalazione",
          token: localStorage.user_token,
          tabella: [
            {
              id_segnalazione: this.tempSegnalazione.id_segnalazione,
              stato: this.id_stato_tmp,
              esito: this.id_esito_tmp,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.gestisci_stato_esito = false;
            this.segnalazioneDettaglio = false;
            this.$refs.SnackbarQV.print(
              "success",
              "Stato ed esito aggiornati con successo."
            );
            this.inizializza();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    getProfili() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_profili = res.data.result.profili
              ? res.data.result.profili
              : [];
            return 1;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
            return 0;
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
          return 0;
        });
    },
    openImage(arg) {
      this.image_data = arg;
      this.showImage = true;
    },
    getTipo(id) {
      for (const e of this.tipi_segnalazione) {
        if (e.id_tabella == id) {
          return e.des;
        }
      }
      return "nessuno";
    },
    getTabella() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "TIPOLOGIA_SEGNALAZIONE",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tipi_segnalazione = res.data;
            this.lista_profili.forEach((p) => {
              const p_tmp = new Object();
              p_tmp.des_profilo_utente = p.des_profilo_utente;
              p_tmp.id_profilo_utente = p.id_profilo_utente;
              this.lista_profili_auto.push(p_tmp);
            });
            this.headers_autorizzazioni.push({
              text: "Profilo",
              value: "des_profilo_utente",
              sortable: false,
              width: "200px",
            });
            this.tipi_segnalazione.forEach((t) => {
              this.lista_profili_auto.forEach((a) => {
                // Inserisco il tipo di questionario nell'oggetto.
                a[t.des.toLowerCase()] = new Object();
                a[t.des.toLowerCase()].id_segnalazione_tipo = t.id_tabella;
                a[t.des.toLowerCase()].id_profilo_utente = a.id_profilo_utente;
                a[t.des.toLowerCase()].value = 0;
              });

              // Inserisco un header per ogni tipo di questionario.
              this.headers_autorizzazioni.push({
                text: t.des,
                value: t.des.toLowerCase(),
                sortable: false,
                width: "50px",
              });
            });
            this.tableKey = !this.tableKey;

            this.getAutorizzazioni();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    switchAutorizzazione(arg, val) {
      arg[val].value = arg[val].value === 0 ? 1 : 0;
      this.key_tabella = this.key_tabella === 0 ? 1 : 0;
    },
    setOpzioni() {
      this.salvaAutorizzazioni();
    },
    async inizializza() {
      this.loading = true;
      await this.getNote();

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioni",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.data.statusCode === 200) {
            this.segnalazioni = new Array();
            this.segnalazioni = Array.from(res.data.result.segnalazioni);
            this.segnalazioni.forEach((e) => {
              e.lista_note = [];
              this.note.forEach((n) => {
                if (n.id_segnalazione == e.id_segnalazione) {
                  e.lista_note.push(n);
                }
              });
              if (e.lista_note.length != 0) {
                e.ultimo_stato =
                  e.lista_note[e.lista_note.length - 1].des_stato;
                e.lista_note[e.lista_note.length - 1].ultima = true;
              }
            });
            this.getfilters();
            this.$forceUpdate();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
          this.loading = false;
        })
        .catch((err) => {
          if (err) {
            console.log(this.segnalazioni);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
            this.loading = false;
          }
        });
    },
    gettabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "'STATO_ANOMALIE','ESITO_SEGNALAZIONE'",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tipologia_stato =
              res.data.STATO_ANOMALIE != null && res.data.STATO_ANOMALIE != ""
                ? res.data.STATO_ANOMALIE
                : [];
            this.tipologia_esito =
              res.data.ESITO_SEGNALAZIONE != null &&
              res.data.ESITO_SEGNALAZIONE != ""
                ? res.data.ESITO_SEGNALAZIONE
                : [];

            // Registro gli id_tabella notevoli
            if (res.data.STATO_ANOMALIE) {
              this.id_stato_open =
                res.data.STATO_ANOMALIE.filter((e) => e.cod == "OPEN").length >
                0
                  ? res.data.STATO_ANOMALIE.filter((e) => e.cod == "OPEN")[0]
                      .id_tabella
                  : -1;
              this.id_stato_progress =
                res.data.STATO_ANOMALIE.filter((e) => e.cod == "PROGRESS")
                  .length > 0
                  ? res.data.STATO_ANOMALIE.filter(
                      (e) => e.cod == "PROGRESS"
                    )[0].id_tabella
                  : -1;
              this.id_stato_closed =
                res.data.STATO_ANOMALIE.filter((e) => e.cod == "CLOSED")
                  .length > 0
                  ? res.data.STATO_ANOMALIE.filter((e) => e.cod == "CLOSED")[0]
                      .id_tabella
                  : -1;
            }

            if (res.data.ESITO_SEGNALAZIONE) {
              this.id_esito_ok =
                res.data.ESITO_SEGNALAZIONE.filter((e) => e.cod == "OK")
                  .length > 0
                  ? res.data.ESITO_SEGNALAZIONE.filter((e) => e.cod == "OK")[0]
                      .id_tabella
                  : -1;
              this.id_esito_nok =
                res.data.ESITO_SEGNALAZIONE.filter((e) => e.cod == "NOK")
                  .length > 0
                  ? res.data.ESITO_SEGNALAZIONE.filter((e) => e.cod == "NOK")[0]
                      .id_tabella
                  : -1;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    formatData(data) {
      if (data != null) {
        data = data.split("T");
        return data == null || data[0] == ""
          ? "N/D"
          : moment(data[0]).format("DD-MM-YYYY") + ` ${data[1]}`;
      }
    },
    saveImageAsFile(base64) {
      let link = document.createElement("a");
      link.setAttribute("href", base64);
      link.setAttribute("download", this.tempSegnalazione.cod_documento);
      link.click();
    },
    setNota(nota) {
      if (nota.id_segnalazione == null || nota.id_segnalazione == undefined) {
        nota.id_segnalazione = this.tempSegnalazione.id_segnalazione;
      }

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioninote",
          token: localStorage.getItem("user_token"),
          nota: {
            id_segnalazione_nota: nota.id_segnalazione_nota,
            id_segnalazione: nota.id_segnalazione,
            des_azione: nota.des_azione,
            id_stato: nota.id_stato,
            validita: 1,
          },
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.$refs.SnackbarQV.print("success", "Salvataggio effettuato");
          this.nuova_nota = { des_azione: "", id_stato: null };
          if (this.dialog_modifica_nota == true) {
            this.nota_selez = {};
            this.dialog_modifica_nota = false;
          }
          this.segnalazioneDettaglio = false;
          this.inizializza();
        }
      });
    },

    /* getStati() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "STATO_ANOMALIE",
          filter: "validita = 1",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.tipologia_stato = res.data ? res.data : [];
        }
      });
    },
 */
    showSegnalazione(item) {
      for (let i = 0; i < this.segnalazioni.length; i++) {
        if (
          this.segnalazioni[i].id_documento_dettaglio ==
          item.id_documento_dettaglio
        ) {
          this.tempSegnalazione = Object.assign({}, this.segnalazioni[i]);
          break;
        }
      }
      this.tempSegnalazione = Object.assign({}, item);
      this.getImmagini(item.id_segnalazione);
      this.segnalazioneDettaglio = true;
    },
    getNote() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioninote",
          token: localStorage.getItem("user_token"),
        },
      };

      return this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode === 200) {
          this.note = res.data.result.note;
          return 1;
        } else {
          return 0;
        }
      });
    },
    getImmagini(id) {
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioneimmagini",
          id_segnalazione: id,
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode === 200) {
          this.immagini = Array.from(res.data.result.immagini);
        }
        this.loading = false;
      });
    },
    getfilters() {
      var found = false;
      for (let i = 0; i < this.segnalazioni.length; i++) {
        for (let i2 = 0; i2 < this.articoli.length; i2++) {
          if (this.segnalazioni[i].cod_articolo == this.articoli[i2]) {
            found = true;
          }
        }
        if (!found) {
          this.articoli.push(this.segnalazioni[i].cod_articolo);
        }
        found = false;
        for (let i2 = 0; i2 < this.ordini.length; i2++) {
          if (this.segnalazioni[i].cod_documento == this.ordini[i2]) {
            found = true;
          }
        }
        if (!found) {
          this.ordini.push(this.segnalazioni[i].cod_documento);
        }
        found = false;
      }
    },
    showFilter() {
      if (this.filtered.length == 0) {
        this.changeFilters();
      }
      this.filterVisible = !this.filterVisible;
    },
    changeFilters() {
      this.filtered = this.segnalazioni.filter(
        (item) =>
          (item.cod_documento == this.ordFilter || this.ordFilter == "tutti") &&
          (item.cod_articolo == this.artFilter || this.artFilter == "tutti") &&
          (item.stato == this.statoFilter || this.statoFilter == -1) &&
          (item.tipo == this.tipFilter || this.tipFilter == -1)
      );
    },
    getAutorizzazioni() {
      var request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getsegnalazioniautorizzazioni",
          token: localStorage.user_token,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Per ogni oggetto della response...
            res.data.result.autorizzazioni.forEach((r) => {
              // ... Cerco il profilo corrispondente in tabella...
              this.lista_profili_auto.forEach((a) => {
                // ... E quando lo trovo ...
                if (a.id_profilo_utente === r.id_profilo_utente) {
                  /* Uso l'id_tabella della response per trovare
                   * il tipo specifico di questionario da configurare;
                   * imposto anche l'id_questionario_autorizzazioni
                   * della tipologia per avere la chiave primaria da
                   * modificare quando comporrò la set. */
                  for (let field in a) {
                    if (
                      a[field]?.id_segnalazione_tipo === r.id_segnalazione_tipo
                    ) {
                      a[field].value = r.value;
                      a[field].id_segnalazione_autorizzazione =
                        r.id_segnalazione_autorizzazione;
                    }
                  }
                }
              });
            });

            // Interrompo l'overlay di caricamento.
            this.caricamento_dati = false;
            this.key_tabella = this.key_tabella == 0 ? 1 : 0;
          } else {
            // Interrompo l'overlay di caricamento.
            this.caricamento_dati = false;

            // Stampo una snackbar di avviso.
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione con il server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          // Interrompo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Stampo un avviso in console e una snackbar.
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione con il server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaAutorizzazioni() {
      const arr_tmp = new Array();
      this.lista_profili_auto.forEach((a) => {
        for (let field in a) {
          if (field != "des_profilo_utente" && field != "id_profilo_utente") {
            arr_tmp.push(Object.assign({}, a[field]));
          }
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setautorizzazionisegnalazioni",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Salvataggio avvenuto con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile salvare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile salvare i dati."
          );
        });
    },
  },
};
</script>